import { render } from "./AddOrSelectInput.vue?vue&type=template&id=1c0445dd"
import script from "./AddOrSelectInput.vue?vue&type=script&lang=js"
export * from "./AddOrSelectInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__